import { Slider } from "@nextui-org/react";
import React from "react";

import { Row, Text } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

const LORA_SCALE_MIN = 0;
const LORA_SCALE_MAX = 1.0;
const LORA_SCALE_STEP = 0.01;

type ConversationImageLoraScaleProps = {
  loraScale: number;
  onLoraScaleChange: (newLoraScale: number | number[]) => void;
};

/** LoRA scale label, description and slider. */
const ConversationImageLoraScale = ({ loraScale, onLoraScaleChange }: ConversationImageLoraScaleProps) => (
  <>
    <Row className="leading-5">
      <Text h6 mNone>
        <Trans i18nKey="chat:modal.imageSettings.loraScale.adjustLabel" />
      </Text>
    </Row>
    <Row>
      <Text variant={"smallest"}>
        <Trans i18nKey="chat:modal.imageSettings.loraScale.description" />
      </Text>
    </Row>

    <Row className="pb-1 gap-1">
      <Text className="w-9 whitespace-nowrap">{loraScale}</Text>
      <Slider
        className="flex-1"
        size="sm"
        minValue={LORA_SCALE_MIN}
        maxValue={LORA_SCALE_MAX}
        step={LORA_SCALE_STEP}
        value={loraScale}
        onChange={onLoraScaleChange}
        aria-labelledby="temperature"
      />
    </Row>
  </>
);

export default React.memo(ConversationImageLoraScale);
